document.addEventListener('DOMContentLoaded', function () {
    toggleProductDetailModal();
});

function toggleProductDetailModal() {
    const trigger = jQuery('.trigger-product-detail-modal');
    const close = jQuery('.close-product-detail-modal');

    trigger.on('click', function () {
        const modal = jQuery(this).next('.modal');
        modal.toggleClass('active');
    });

    close.on('click', function () {
        const thisElement = jQuery(this);
        const modal = thisElement.parent('.modal');
        modal.toggleClass('active');
    });
}